<template>
    <el-dialog
        :model-value="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        class="submit-modal"
        width="500px"
        :show-close="false"
        center
    >
        <template #header="{ close }">
            <div class="custom-header">
                <span @click="close" class="close-text">
                    {{ $trans("web_profile.cancel") }}
                    <el-icon class="custom-close-icon"><Close /></el-icon>
                </span>
            </div>
        </template>
        
        <div class="modal-body-content">
            {{ $trans("web_profile.regenerate_claim_confirmation") || "Are you sure you want to regenerate the claim using AI? The current claim will be overwritten." }}
        </div>

        <template #footer>
            <div class="dialog-footer">
                <el-button
                    class="grey-button"
                    @click="$emit('update:modelValue', false)"
                >
                    {{ $trans("web_profile.cancel") }}
                </el-button>
                <el-button
                    class="blue-button"
                    type="primary"
                    @click="handleConfirm"
                >
                    {{ $trans("web_profile.accept") || "Generate" }}
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { Close } from "@element-plus/icons-vue";

export default {
    name: "ConfirmSummaryGenerationModal",
    components: {
        Close,
    },
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    emits: ["update:modelValue", "confirm"],
    methods: {
        handleClose() {
            this.$emit("update:modelValue", false);
        },
        handleConfirm() {
            this.$emit("confirm");
            this.handleClose();
        },
    },
};
</script>

<style scoped>
.submit-modal :deep(.el-dialog__header) {
    padding: 15px 20px 10px;
    margin-right: 0;
    border-bottom: none;
}
.submit-modal :deep(.el-dialog__body) {
    padding: 10px 30px 20px;
    font-size: 22px;
    color: #3c3c3c;
    text-align: center;
}
.submit-modal :deep(.el-dialog__footer) {
    border-top: none;
    padding: 10px 20px 20px;
}
:deep(.el-dialog__headerbtn) {
    position: absolute;
    top: 6px;
    right: 0;
    padding: 0;
    width: 88px;
    height: 63px;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: var(--el-message-close-size, 16px);
}
.custom-header {
    display: flex;
    justify-content: flex-end;
    position: relative;
    font-size: 18px;
    font-style: italic;
    color: #000;
}
.close-text {
    cursor: pointer;
    display: flex;
    align-items: center;
}
.dialog-footer {
    display: flex;
    gap: 15px;
    width: 100%;
}
.dialog-footer .el-button {
    flex-grow: 1;
    width: 100%;
    font-size: 16px;
    padding: 18px 10px;
    border-radius: 4px;
}
.grey-button {
    background-color: #f2f2f2;
    border-color: #f2f2f2;
    color: #606266;
}
.grey-button:hover,
.grey-button:focus {
    background-color: #e6e6e6;
    border-color: #e6e6e6;
    color: #303133;
}
.blue-button {
    background-color: #41abc4;
    border-color: #41abc4;
    color: white;
}
.blue-button:hover,
.blue-button:focus {
    background-color: #3693a9;
    border-color: #3693a9;
}
.modal-body-content {
    font-size: 22px;
    color: #3c3c3c !important;
}
.custom-close-icon {
    font-size: 35px;
    margin-left: 10px;
    vertical-align: middle;
}
</style>